
const urls = {
    assets: './app/static/',
    mailer: 'engine/send.php',
    mailer2: 'http://localhost/cajeff/engine/send.php',
    GA_TRACKING_ID: 'UA-18261922-14'
};

export { urls };